import messagePopupManager from "../../util/messagePopupManager";
import objectUtils from "../../util/objectUtils";
import axios from "axios";

export default {
    state: () => ({
        agencyList : null,
        agenciesBySailList : null,
        agency : null,
        transactionList : null,
        credit : null,
        user : {},
        userList : null,
        agencyReportData : null,
        agencyCommissionRates : null
    }),
    mutations: {
        setAgencyList:function (state,agencyList){
            state.agencyList = agencyList;
        },
        setAgenciesBySailList:function (state,agencyList){
            state.agenciesBySailList = agencyList;
        },
        setAgency:function (state,agency){
            state.agency = agency
        },
        setUserList:function (state,userList){
            state.userList = userList;
        },
        setUser:function (state,user){
            state.user = user
        },
        addUser:function (state,user){
            state.userList.push(user)
        },
        setTransactionList:function (state,transactionList){
            state.transactionList = transactionList;
        },
        setCredit:function (state,credit){
            state.credit = credit;
        },
        setAgencyReportData:function (state, report){
            state.agencyReportData = report;
        },
        setAgencyCommissionRates:function (state, agencyCommissionRates){
            state.agencyCommissionRates = agencyCommissionRates;
        }
    },
    getters: {
        getAgencyList : state => {
            return state.agencyList
        },
        getAgenciesBySailList : state => {
            return state.agenciesBySailList
        },
        getAgencyListMap : state => {
            if(state.agencyList == null){
                return null
            }
            return state.agencyList.reduce(function (map, cabinType) {
                map[cabinType.id] = cabinType;
                return map;
            }, {});
        },
        getAgency : state => {
            return state.agency
        },
        getAgencyUserList : state => {
            return state.userList
        },
        getUserListMap : state => {
            if(state.userList == null){
                return null
            }
            return state.userList.reduce(function (map, user) {
                map[user.id] = user;
                return map;
            }, {});
        },
        getAgencyUser : state => {
            return state.user
        },
        getTransactionList : state => {
            return state.transactionList
        },
        getCredit : state => {
            return state.credit
        },
        getUserList : state => {
            return state.userList;
        },
        getAgencyReportData : state => {
            return state.agencyReportData;
        },
        getAgencyCommissionRates : state => {
            return state.agencyCommissionRates;
        }
    },
    actions:{
        loadAgency(context, id){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/agency/"+id, {headers})
                .then((response) => {
                    context.commit("setAgency",response.data)

                    return axios.get(context.getters.getServiceUrl + "/admin-api/agency/"+id+"/creditAccount", {headers});
                })
                .then(response => {
                    context.commit("setCredit",response.data.remainingCredit);
                    context.commit("setTransactionList",response.data.transactions);

                    return axios.get(context.getters.getServiceUrl + "/admin-api/agency/"+id+"/users", {headers});
                })
                .then(response => {
                    context.commit("setUserList",response.data);

                    return context.getters.getAgency;
                })
        },
        loadAgencyBookingList(context, agencyId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency/"+agencyId+"/bookings", {headers}).then(response => {
                return response.data;
            })
        },
        loadAgencyList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency", {headers}).then(response => {
                context.commit("setAgencyList",response.data);
            })
        },
        loadAgencyBySailList(context,sailId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency/by-sail/"+sailId, {headers}).then(response => {
                context.commit("setAgenciesBySailList",response.data);
            })
        },
        addCredit(context, amount){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            let request = {"amount" : amount};
            const agencyId = context.getters.getAgency.id;
            return axios.post(context.getters.getServiceUrl + "/admin-api/agency/"+agencyId+"/creditAccount/add",
                request,{headers})
                .then(() => {
                    return context.dispatch("loadAgency",agencyId).then(() => {
                        messagePopupManager.showSuccess();
                    });
                });
        },
        removeCredit(context, amount){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            let request = {"amount" : amount};
            const agencyId = context.getters.getAgency.id;
            return axios.post(context.getters.getServiceUrl + "/admin-api/agency/"+agencyId+"/creditAccount/remove",
                request,{headers})
                .then(() => {
                    return context.dispatch("loadAgency",agencyId).then(() => {
                        messagePopupManager.showSuccess();
                    });
                });
        },
        updateAgency(context, agency){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/agency", agency,{headers})
                .then((response) => {
                    context.commit("setAgency",response.data)

                    return response.data;
                })
        },
        createAgency(context, agency){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            let request = {
                agency : agency,
                masterUser : context.getters.getAgencyUser
            }

            return axios.post(context.getters.getServiceUrl + "/admin-api/agency", request,{headers})
                .then((response) => {
                    return context.dispatch("loadAgency",response.data.id);
                })
        },
        updateUser(context, user){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/agency/users", user,{headers})
                .then((response) => {
                    let userList = context.getters.getUserList;
                    userList.forEach((user) => {
                        if(user.id === response.data.id) {
                            objectUtils.deepCopy(user, response.data);
                        }
                    });

                    context.commit("setUserList",userList);
                    return response.data;
                })
        },
        changePassword(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/agency/users/"+request.userId+"/updatePassword", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deActiveUser(context, user){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency/"+user.agencyId+"/users/"+user.id+"/deactivate",{headers})
                .then((response) => {
                    user.active = false;
                    context.commit("setUser",user)
                    let userList = context.getters.getUserList;
                    userList.forEach((userIteration) => {
                        if(userIteration.id === user.id) {
                            objectUtils.deepCopy(userIteration, user);
                        }
                    });
                    context.commit("setUsers",userList)
                    return response.data;
                })
        },
        activeUser(context, user){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency/"+user.agencyId+"/users/"+user.id+"/activate",{headers})
                .then((response) => {
                    user.active = true;
                    context.commit("setUser",user)
                    let userList = context.getters.getUserList;
                    userList.forEach((userIteration) => {
                        if(userIteration.id === user.id) {
                            objectUtils.deepCopy(userIteration, user);
                        }
                    });
                    context.commit("setUsers",userList)
                    return response.data;
                })
        },
        createUser(context, user){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            user.agencyId = context.getters.getAgency.id

            return axios.post(context.getters.getServiceUrl + "/admin-api/agency/users",user,{headers})
                .then((response) => {
                    user.active = true;
                    user.id = response.id;
                    context.commit("setUser",user)
                    context.commit("addUser",user)
                    return response.data;
                })
        },
        loadUserList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency/users",{headers})
                .then((response) => {
                    context.commit("setUserList",response.data)
                    return response.data;
                })
        },
        loadAgencyReportData(context, request){

            //TODO: teporary Code Below
            request = {id:1};
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/report/agency/"+request.id,{headers})
                .then((response) => {
                    context.commit("setAgencyReportData", response.data);
                    return response.data;
                })
        },

        generateAgencyReport(context, request){

            //TODO: teporary Code Below
            request = {id:1};
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/report/generate-agency-report/"+request.id,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadAgencyCommissionRateList(context, agencyId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency/commission-rate/by-agency/"+agencyId,{headers})
                .then((response) => {
                    context.commit("setAgencyCommissionRates", response.data);
                    return response.data;
                });
        },
        createAgencyCommissionRate(context, agencyCommissionRate){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/agency/commission-rate/", agencyCommissionRate,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        updateAgencyCommissionRate(context, agencyCommissionRate){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/agency/commission-rate", agencyCommissionRate,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deleteAgencyCommissionRate(context, agencyCommissionRateId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/agency/commission-rate/"+agencyCommissionRateId,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadAgencyPaymentView(context, agencyId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency/"+agencyId+"/payment-view",{headers})
                .then((response) => {
                    return response.data;
                });
        },
    }
}

